export default __webpack_public_path__ + "content/media/34.23dc692e.jpg";